import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
const Breadcrumb = () => {
  const { detail, status } = useAppSelector((state) => state.campaign);
  const { pathname } = useLocation();
  let multiPathname = pathname.split("/");
  let paths = multiPathname.filter((path) => path.length > 0);
  let path_bread: string[] = [];
  path_bread[0] = paths[paths.length - 1];
  for (let index = 0; index < paths.length - 1; index++) {
    path_bread[index + 1] = paths[index];
  }
  function capitalize(text: string) {
    const lower = text.toLowerCase();
    return text.charAt(0).toUpperCase() + lower.slice(1);
  }

  if (
    status === "getDetailCampaign_loading" ||
    status === "getCampaigns_loading"
  ) {
    return (
      <div className="c-breadcrumb">
        <div className="c-breadcrumb__skeleton" />
      </div>
    );
  }
  if (path_bread[path_bread.length - 1] === "campaigns" || path_bread[path_bread.length - 1] === "sweepstakes" ) {
    return (
      <div className="c-breadcrumb">
        {path_bread.map((path, i) => {
          if (i === 0) {
            return (
              <span className="c-breadcrumb__title c-breadcrumb__title--order" key={i}>
                {(path_bread[path_bread.length - 1] === "sweepstakes") ? 'Sweepstakes' : detail.name}
              </span>
            );
          }
          if (path === "mypurls") {
            return (
              <>
                <span className="c-breadcrumb__item" key={i}>My PURLs</span>
                <span className="c-breadcrumb__item" key={i}>-</span>
              </>
            );
          }
          return (
            <Link
              to={(path_bread[path_bread.length - 1] === "sweepstakes") ? "/mypurls/sweepstakes" : "/mypurls/campaigns"}
              className="c-breadcrumb__item c-breadcrumb__item-link"
              key={i}
            >
              {capitalize(path)}
            </Link>
          );
        })}
      </div>
    );
  } else {
    return (
      <div className="c-breadcrumb">
        {path_bread.map((path, index, allpatch) => {
          let redirect = "";
          for (let j = 0; j <= index; j++) {
            redirect = redirect + "/" + paths[j];
          }
          if (index === 0) {
            return (
              <span className="c-breadcrumb__title c-breadcrumb__title--order" key={index}>
                {capitalize(path)}
              </span>
            );
          }
          if (path === "mypurls") {
            return (
              <>
                <span className="c-breadcrumb__item" key={index}>My PURLs</span>
                {index !== allpatch.length - 1 && (
                  <span className="c-breadcrumb__item">-</span>
                )}
              </>
            );
          }
          return (
            <>
              <Link
                to={redirect}
                className="c-breadcrumb__item c-breadcrumb__item-link"
                key={index}
              >
                {capitalize(path)}
              </Link>
              {index !== allpatch.length - 1 && (
                <span className="c-breadcrumb__item">-</span>
              )}
            </>
          );
        })}
      </div>
    );
  }
};
export default Breadcrumb;
